/**
 * Constants for the AuditLogViewer module
 */

import { type SessionData, type TCodeData } from '../types';

export const INITIAL_ITEMS_COUNT = 5;

export const SAMPLE_AUDIT_DATA: TCodeData[] = [
  {
    id: '1',
    description: 'User authentication and session management events',
  },
  {
    id: '2',
    description: 'Privileged access and entitlement modifications',
  },
  {
    id: '3',
    description: 'Sensitive data access and file operations',
  },
  {
    id: '4',
    description: 'System configuration and infrastructure changes',
  },
  {
    id: '5',
    description: 'Compliance and audit trail events',
  },
  {
    id: '6',
    description: 'Security incident and threat detection',
  },
  {
    id: '7',
    description: 'Integration and API access events',
  },
];

export const MOCK_SESSION_DATA: SessionData[] = [
  { label: 'Session ID', value: 'SESS_2024_001234' },
  { label: 'User ID', value: 'john.doe@company.com' },
  { label: 'Start Time', value: '2024-01-15 09:30:15 UTC' },
  { label: 'End Time', value: '2024-01-15 17:45:22 UTC' },
  {
    label: 'Status',
    value: 'Completed',
    type: 'status',
    status: 'completed',
  },
  { label: 'Actions Performed', value: '47' },
  {
    label: 'Risk Level',
    value: 'Low',
    type: 'risk',
    risk: 'low',
  },
];

export const RISK_LEVELS = {
  LOW: { value: 25, level: 'low', label: 'Low Risk' },
  MEDIUM: { value: 50, level: 'medium', label: 'Medium Risk' },
  HIGH: { value: 85, level: 'high', label: 'High Risk' },
} as const;

export const STATUS_INDICATORS = {
  completed: '#10b981',
  active: '#f59e0b',
  terminated: '#ef4444',
} as const;

export const RISK_INDICATORS = {
  low: '#10b981',
  medium: '#f59e0b',
  high: '#ef4444',
} as const;
